module.exports = __webpack_public_path__ + "img/标题文字_行业解决方案.eae26534.svg";